<circle-progress
  [percent]="percentage"
  [animation]="true"
  [animationDuration]="300"
  [title]="title"
  [lazy]="false"
></circle-progress>
